// extracted by mini-css-extract-plugin
export default {"button":"jq-z","reviewSort":"kq-z"};